<template>
  <div class="coindetail">
    <XR-head titleText="提现明细" :rightShow="false"></XR-head>
    <div class="detail-traceAmt" v-if="!loaded">
        <span class="amt">{{streamDetailInfo.txje.toFixed(2)}}</span>
    </div>
    <div class="row-list" v-if="!loaded">                      
      <div class="row-item">
          <p class="item-title">提现单号</p>
          <p class="item-value">{{streamDetailInfo.txNo}}</p>
      </div>
	  <div class="row-item">
          <p class="item-title">提现金额</p>
          <p class="item-value">{{streamDetailInfo.txje}}</p>
      </div>
	  <div class="row-item">
          <p class="item-title">提现手续费</p>
          <p class="item-value">{{streamDetailInfo.fwje}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">提现处理状态</p>
          <p class="item-value">{{streamDetailInfo.statusName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">提现时间</p>
          <p class="item-value">{{streamDetailInfo.txdatename}}</p>
      </div>
	  <div class="row-item">
          <p class="item-title">提现来源</p>
          <p class="item-value">{{streamDetailInfo.bankName}}</p>
      </div>
	  <div class="row-item">
          <p class="item-title">提现账号</p>
          <p class="item-value">{{streamDetailInfo.bankno}}</p>
      </div>
	  <div class="row-item">
          <p class="item-title">提现账户</p>
          <p class="item-value">{{streamDetailInfo.bankuser}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">备注</p>
          <p class="item-value">{{streamDetailInfo.remark}}</p>
      </div>
    </div>
    <XR-toast  ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loaded:true,        
        streamDetailInfo :{
            ysje:0,
            txje:0,
            fwje:0,
            yfje:0,
            status:0,
            statusName:"",
            txdatename:'',
            txNo:"",
            bankno:"",
            bankName:"",
			bankaddress:"",
			bankuser:"",
			remark:""
        }
    };
  },
  mounted: function(){
    this.$refs.XRtoast.load()
    if(this.$route.query.txNo){
        this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetMyMoneyCoreTxDetail",
        JSON.stringify({'txNo': ths.$route.query.txNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.hide()
          ths.streamDetailInfo = res.Data;
          ths.loaded= false
        }
      });
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .coindetail{
    background: white;
}
.coindetail .detail-traceAmt {
    overflow:hidden;
    text-align:center;
    margin: 0 20px;
    border-bottom:1px solid #efefef;
    padding:35px 0 35px;
}
    .coindetail .detail-traceAmt .amt {
        font-size:30px;
    }
    .coindetail .detail-traceAmt .unit {
        font-size:12px;
        color:#aaa;
    }
.coindetail .row-list {
    margin: 0 20px;
    padding:30px 0;
}
   .coindetail  .row-list .row-item {
        padding:10px 0;
    }
      .coindetail   .row-list .row-item .item-title {
            color:#ccc;
            font-size:16px;
        }
       .coindetail  .row-list .row-item .item-value {
            font-size:12px;
            padding-top:2px;
            word-break: break-all;
        }
    .coindetail .row-list.last {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/myMoneyCoreTxdetail.vue